package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.flex
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLInputElement
import org.w3c.files.File
import waldo.sankan.lineamunicipalkmp.model.Incidencia
import kotlin.js.Date

// --- FUNCIONES DE UTILIDAD (SIN CAMBIOS) ---
private fun formatTimestamp(timestamp: Long?): String {
    if (timestamp == null) return "N/A"
    val date = kotlin.js.Date(timestamp)
    return "${date.getDate().toString().padStart(2, '0')}/" +
            "${(date.getMonth() + 1).toString().padStart(2, '0')}/" +
            "${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}"
}

private fun formatDuration(ms: Long?): String {
    if (ms == null || ms <= 0) return "N/A"
    val totalMinutes = kotlin.math.floor(ms / 60000.0)
    val totalHours = kotlin.math.floor(totalMinutes / 60.0)
    val days = kotlin.math.floor(totalHours / 24.0).toInt()
    val hours = (totalHours % 24).toInt()
    val minutes = (totalMinutes % 60).toInt()
    val parts = mutableListOf<String>()
    if (days > 0) parts.add("$days d")
    if (hours > 0) parts.add("$hours h")
    if (minutes > 0 || parts.isEmpty()) parts.add("$minutes min")
    return parts.joinToString(" ")
}

private fun formatElapsedTime(startTime: Long?): String {
    if (startTime == null) return "N/A"
    val diff = kotlin.js.Date.now() - startTime
    return formatDuration(diff.toLong())
}

// --- COMPONENTES REUTILIZABLES (SIN CAMBIOS) ---
@Composable
private fun FilterSectionDron(uiState: AdminPanelUiState, viewModel: AdminPanelViewModel, onBack: () -> Unit) {
    Div({
        style {
            display(DisplayStyle.Flex);
            flexDirection(FlexDirection.Row);
            gap(24.px);
            padding(12.px)
            border(1.px, LineStyle.Solid, Color("#cccccc"));
            borderRadius(8.px);
            marginBottom(24.px)
            alignItems(AlignItems.Center);
            flexWrap(FlexWrap.Wrap);
            fontSize(16.px);
            backgroundColor(Color("#f2f2f2"))
        }
    }) {
        Div({ style { flex(1) } })
        Button(attrs = {
            onClick { viewModel.onShowPlanCuadranteModal() }
            style {
                padding(10.px, 20.px);
                fontSize(14.px);
                fontWeight("bold");
                color(Color.white);
                backgroundColor(Color("#1A73E8"));
                borderWidth(0.px);
                borderRadius(8.px)
            }
        }) { Text("\uD83D\uDDFA\uFE0F Plan Cuadrante") }
        Button(attrs = {
            onClick { onBack() }
            style {
                padding(10.px, 20.px);
                fontSize(14.px);
                fontWeight("bold");
                color(Color.white);
                backgroundColor(Color("#FB8C00"));
                borderWidth(0.px);
                borderRadius(8.px)
            }
        }) { Text("Volver al Panel") }
    }
}

@Composable
private fun ContentBox(modifier: StyleBuilder.() -> Unit = {}, content: @Composable () -> Unit) {
    Div({
        style {
            backgroundColor(Color.white)
            borderRadius(8.px)
            padding(16.px)
            color(Color.black)
            property("box-shadow", "0px 4px 12px rgba(0,0,0,0.1)")
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)

            // --- ¡LA ORDEN DE DISCIPLINA ESTRICTA! ---
            // Le decimos al box que su altura mínima es 0, lo que le permite
            // encogerse y obliga a su contenido interior a respetar los límites.
            minHeight(0.px)

            // Aplicamos cualquier modificador adicional al final
            modifier()
        }
    }) {
        content()
    }
}

@Composable
private fun ImagePreviewBox(title: String, imageUrl: String?) {
    Div({ style { flex(1) } }) {
        H4({ style { margin(0.px, 0.px, 8.px, 0.px) } }) { Text(title) }
        Div({
            style {
                width(100.percent)
                property("aspect-ratio", "1 / 1")
                backgroundColor(Color("#e9ecef"))
                borderRadius(8.px)
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
            }
        }) {
            if (imageUrl != null) {
                Img(src = imageUrl, alt = title) { style { width(100.percent); height(100.percent); property("object-fit", "cover"); borderRadius(8.px) } }
            } else {
                P({ style { fontStyle("italic"); color(Color("#6c757d")) } }) { Text("Pendiente") }
            }
        }
    }
}
private fun esDiaDiferente(fechaActual: Long?, fechaAnterior: Long?): Boolean {
    if (fechaActual == null) return false
    if (fechaAnterior == null) return true
    val d1 = Date(fechaActual)
    val d2 = Date(fechaAnterior)
    return d1.getFullYear() != d2.getFullYear() ||
            d1.getMonth() != d2.getMonth() ||
            d1.getDate() != d2.getDate()
}
@Composable
private fun CommunicationHistoryBox1(comentarios: List<waldo.sankan.lineamunicipalkmp.model.ComentarioIncidencia>) {
    Div({
        style {
            flex(1); height(500.px); overflowY("auto"); padding(16.px)
            backgroundColor(Color("#1976D2")) // FONDO AZUL FIXO
            borderRadius(12.px); display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column); gap(12.px)
        }
    }) {
        if (comentarios.isEmpty()) {
            Div({ style { color(rgba(255,255,255,0.6)); textAlign("center"); paddingTop(20.px) } }) {
                Text("No hay mensajes previos con el Mando.")
            }
        } else {
            val mensajesOrdenados = comentarios.sortedBy { it.fecha }

            mensajesOrdenados.forEachIndexed { index, msg ->
                val fechaActual = msg.fecha
                val fechaAnterior = if (index > 0) mensajesOrdenados[index - 1].fecha else null

                if (esDiaDiferente(fechaActual, fechaAnterior)) {
                    Div({ style { display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); margin(16.px, 0.px) } }) {
                        Span({
                            style {
                                backgroundColor(rgba(255, 255, 255, 0.2))
                                color(Color.white); padding(4.px, 12.px); borderRadius(8.px)
                                fontSize(12.px); fontWeight("bold")
                            }
                        }) {
                            val d = Date(fechaActual!!)
                            Text(d.toLocaleDateString("es-CL", js("{'weekday': 'long', 'day': 'numeric', 'month': 'long'}")))
                        }
                    }
                }

                // --- 1. LÓGICA DE IDENTIDAD (RECALIBRADA) ---
                val rol = (msg.rolUsuario ?: "").uppercase().trim()

                // Para el Operador de Dron, "Mio" es solo lo que diga DRON
                val esMio = rol.contains("DRON")

                // Determinamos quién es el emisor para el color y el icono
                val esAdmin = rol.startsWith("ADMIN")
                val esPatrulla = rol == "SOLUCIONADOR"
                val esCiudadano = rol == "CIUDADANO"

                val colorBurbuja = if (esMio) Color("#DCF8C6") else Color.white

                Div({
                    style {
                        display(DisplayStyle.Flex)
                        flexDirection(if (esMio) FlexDirection.RowReverse else FlexDirection.Row)
                        alignItems(AlignItems.FlexEnd)
                        width(100.percent)
                        marginBottom(4.px)
                    }
                }) {
                    // --- ICONO CIRCULAR CON PRIORIDAD DE MANDO ---
                    Div({
                        style {
                            width(35.px); height(35.px); borderRadius(50.percent)
                            display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); alignItems(AlignItems.Center)
                            backgroundColor(rgba(255, 255, 255, 0.2))
                            property("border", "1px solid rgba(255,255,255,0.4)")
                            margin(if (esMio) 0.px else 8.px, if (esMio) 8.px else 0.px)
                            flexShrink(0)
                        }
                    }) {
                        val iconSrc = when {
                            esAdmin -> "lineamunilogo1.png"    // Prioridad 1: Si es Admin, su logo
                            esMio -> "dron1.png"              // Prioridad 2: Si soy yo (Dron)
                            esPatrulla -> "seguridad1.png"    // Prioridad 3: Patrulla
                            esCiudadano -> "ciudadanos1.png"  // Prioridad 4: Vecino
                            else -> "lineamunilogo1.png"
                        }
                        Img(src = iconSrc, attrs = {
                            style { width(24.px); height(24.px); property("object-fit", "contain") }
                        })
                    }

                    // --- LA BURBUJA ---
                    Div({
                        style {
                            maxWidth(75.percent); padding(8.px, 12.px); backgroundColor(colorBurbuja)
                            if (esMio) borderRadius(16.px, 16.px, 0.px, 16.px)
                            else borderRadius(16.px, 16.px, 16.px, 0.px)
                            property("box-shadow", "0px 1px 2px rgba(0,0,0,0.2)")
                            display(DisplayStyle.Flex); flexDirection(FlexDirection.Column)
                        }
                    }) {
                        // --- ETIQUETA DE NOMBRE INTELIGENTE ---
                        val etiquetaNombre = when {
                            esMio -> "Operador Dron"
                            esAdmin -> "Mando Central (Admin)"
                            esPatrulla -> "${msg.usuarioNombre} (Patrulla)"
                            esCiudadano -> "${msg.usuarioNombre} (Ciudadana)"
                            else -> msg.usuarioNombre ?: "Sistema"
                        }

                        B({
                            style {
                                fontSize(11.px)
                                color(if (esMio) Color("#075E54") else if (esAdmin) Color.red else Color("#1976D2"))
                                marginBottom(2.px)
                            }
                        }) {
                            Text(etiquetaNombre)
                        }

                        Span({ style { fontSize(14.px); color(Color.black); lineHeight("1.4") } }) {
                            Text(msg.texto)
                        }

                        Span({
                            style {
                                fontSize(10.px); color(rgba(0,0,0,0.45))
                                alignSelf(AlignSelf.FlexEnd); marginTop(2.px)
                            }
                        }) {
                            val d = Date(msg.fecha ?: 0)
                            Text("${d.getHours().toString().padStart(2,'0')}:${d.getMinutes().toString().padStart(2,'0')}")
                        }
                    }
                }
            }
        }
    }
}
// --- PANTALLA PRINCIPAL REESTRUCTURADA ---
@Composable
fun DroneDetailScreen(
    incidencia: Incidencia,
    viewModel: AdminPanelViewModel,
    uiState: AdminPanelUiState,
    onBack: () -> Unit,
    mensajeParaAdmin: String,
    onMensajeParaAdminChanged: (String) -> Unit,
    onEnviarMensajeAlAdmin: () -> Unit
) {
    var elapsedTime by remember { mutableStateOf(formatElapsedTime(incidencia.fechaCreacion)) }
    var selectedFile by remember { mutableStateOf<File?>(null) }

    LaunchedEffect(incidencia.id) {
        if (incidencia.fechaSolucion == null) {
            while (true) {
                elapsedTime = formatElapsedTime(incidencia.fechaCreacion)
                delay(60000)
            }
        }
    }

    // --- CONTENEDOR PRINCIPAL ---
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            width(100.vw)
            height(100.vh)
            backgroundColor(Color("#f0f2f5"))
            fontFamily("sans-serif")
        }
    }) {
        // --- HEADER (SIN CAMBIOS) ---
        Div({
            style {
                display(DisplayStyle.Flex);
                width(100.percent)
                backgroundColor(Color("#1976D2"))
                property("border-bottom", "2px solid #1565C0")
            }
        }) {
            Div({
                style {
                    width(10.percent); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center)
                    alignItems(AlignItems.Center); padding(24.px); boxSizing("border-box")
                }
            }) {
                Div({
                    style {
                        display(DisplayStyle.Flex); flexDirection(FlexDirection.Column);
                        alignItems(AlignItems.Center); gap(8.px)
                    }
                }) {
                    Img(src = "logo_icon.svg", attrs = { style { height(120.px) } })
                    H2({
                        style {
                            fontSize(24.px); color(Color.white); margin(0.px);
                            property("text-shadow", "1px 1px 2px rgba(0,0,0,0.4)")
                        }
                    }) {
                        Span({ style { fontWeight("normal") } }) { Text("Linea") }
                        Span({ style { fontWeight("bold") } }) { Text("Muni") }
                    }
                    P(attrs = { attr("translate", "no"); style { fontSize(16.px); color(Color("#FB8C00")); fontWeight("bold"); letterSpacing(1.px); margin(0.px) } }) { Text("SMART CITY") }
                }
            }
            Div({
                style {
                    width(90.percent); padding(8.px); display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column); gap(24.px); boxSizing("border-box")
                }
            }) {
                Div({
                    style {
                        display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center);
                    }
                }) {
                    H1({
                        style {
                            color(Color.white); fontSize(32.px); fontWeight(700); paddingTop(20.px)
                            margin(0.px); flex(1); textAlign("center")
                        }
                    }) { Text("FOTO VERIFICACION DRON") }
                }
                FilterSectionDron(uiState = uiState, viewModel = viewModel, onBack = onBack)
            }
        }

        // --- CUERPO PRINCIPAL CON PADDING ---
        Div({
            style {
                flex(1)
                padding(24.px)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                gap(24.px)
            }
        }) {
            // --- FILA 1: VISUAL (FOTOS Y MAPA) ---
            Div({
                style {
                    display(DisplayStyle.Flex)
                    flex(1)
                    gap(24.px)
                }
            }) {
                ContentBox(modifier = { flex(1) }) { ImagePreviewBox("Antes", incidencia.urlImagen) }
                ContentBox(modifier = { flex(1) }) { ImagePreviewBox("Después", incidencia.urlImagenSolucion) }
                ContentBox(modifier = { flex(1) }) { ImagePreviewBox("Verificación Dron", incidencia.urlImagenVerificacionDron) }
                ContentBox(modifier = { flex(1) }) {
                    H4({ style { margin(0.px, 0.px, 8.px, 0.px) } }) { Text("Ubicación") }
                    incidencia.ubicacionGPS?.let { gps ->
                        val mapUrl = "https://maps.google.com/maps?q=${gps.latitude},${gps.longitude}&hl=es&z=15&output=embed"
                        Iframe(attrs = {
                            attr("src", mapUrl)
                            style { width(100.percent); flex(1); border(0.px); borderRadius(8.px) }
                        })
                    } ?: P({ style { fontStyle("italic") } }) { Text("No hay mapa.") }
                }
            }

            // --- FILA 2: OPERACIONAL (DATOS Y ACCIONES) ---
            Div({
                style {
                    display(DisplayStyle.Flex)
                    flex(1)
                    gap(24.px)
                    minHeight(0.px)
                    maxHeight(320.px)
                }
            }) {
                // Caja 2.1: Detalles Generales
                ContentBox(modifier = { flex(1) }) {
                    H3({ style { marginTop(0.px) } }) { Text("Detalles Generales") }
                    P({ style { margin(4.px, 0.px) } }) { B { Text("ID: ") }; Text(incidencia.id) }
                    P({ style { margin(4.px, 0.px) } }) { B { Text("Estado: ") }; Text(incidencia.estado) }
                    P({ style { margin(4.px, 0.px) } }) { B { Text("Tipo: ") }; Text(incidencia.tipoIncidenciaDisplayName ?: "N/A") }
                    P({ style { margin(4.px, 0.px) } }) { B { Text("Comuna: ") }; Text(incidencia.comunaDisplayName ?: "N/A") }
                    P({ style { margin(4.px, 0.px) } }) { B { Text("Reportado por: ") }; Text(incidencia.usuarioNombre ?: "N/A") }
                    P({ style { margin(4.px, 0.px) } }) { B { Text("Fecha Reporte: ") }; Text(formatTimestamp(incidencia.fechaCreacion)) }
                    if (incidencia.fechaSolucion != null) {
                        P({ style { margin(4.px, 0.px) } }) { B { Text("Fecha Solución: ") }; Text(formatTimestamp(incidencia.fechaSolucion)) }
                        P({ style { margin(4.px, 0.px) } }) {
                            B { Text("Tiempo de Solución: ") }
                            val duracionCalculada = incidencia.fechaSolucion!! - (incidencia.fechaCreacion ?: 0)
                            Text(formatDuration(duracionCalculada))
                        }
                    } else {
                        P({ style { margin(4.px, 0.px) } }) { B { Text("Tiempo Transcurrido: ") }; Text(elapsedTime) }
                    }
                    incidencia.ubicacionGPS?.let { gps ->
                        P({ style { margin(4.px, 0.px) } }) { B { Text("Coordenadas: ") }; Text("${gps.latitude}, ${gps.longitude}") }
                    }
                }

                // Caja 2.2: Subir Foto Verificación
                ContentBox(modifier = { flex(1) }) {
                    H3({ style { marginTop(0.px) } }) { Text("Subir Foto Verificación Dron") }
                    if (uiState.isUploadingPhoto) {
                        Div({ style { flex(1); display(DisplayStyle.Flex); alignItems(AlignItems.Center); justifyContent(JustifyContent.Center) } }) {
                            P { Text("Subiendo foto, por favor espere...") }
                        }
                    } else {
                        Input(type = InputType.File) {
                            id("drone-file-input")
                            style { display(DisplayStyle.None) }
                            attr("accept", "image/*")
                            onChange { e ->
                                val input = e.target as HTMLInputElement
                                selectedFile = input.files?.item(0)
                            }
                        }
                        Label(forId = "drone-file-input", attrs = {
                            style {
                                display(DisplayStyle.InlineBlock); property("padding", "10px 20px"); backgroundColor(Color("#1A73E8"));
                                color(Color.white); borderRadius(8.px); cursor("pointer"); textAlign("center"); marginTop(8.px)
                            }
                        }) { Text(if (selectedFile == null) "Seleccionar Archivo" else "Cambiar Archivo") }

                        if (selectedFile != null) {
                            P({ style { fontStyle("italic"); fontSize(14.px); marginTop(12.px); marginBottom(0.px); flex(1) } }) {
                                Text("Archivo: ${selectedFile!!.name}")
                            }
                        } else {
                            Div({ style { flex(1) } })
                        }
                        Button({
                            onClick { selectedFile?.let { file -> viewModel.onUploadDronePhoto(incidencia.id, file) } }
                            if (selectedFile == null) {
                                disabled()
                            }
                            style {
                                width(100.percent); padding(14.px); fontSize(16.px); fontWeight("bold"); color(Color.white);
                                backgroundColor(if (selectedFile == null) Color("#a9a9a9") else Color("#34A853"));
                                borderRadius(8.px); borderWidth(0.px); cursor(if (selectedFile == null) "not-allowed" else "pointer")
                            }
                        }) { Text("Confirmar y Subir Evidencia") }
                    }
                }

                // Caja 2.3: Historial de Comunicaciones
                ContentBox(modifier = { flex(1) }) {
                    CommunicationHistoryBox1(incidencia.comentarios)
                }

                // Caja 2.4: Enviar Mensaje
                ContentBox(modifier = { flex(1) }) {
                    H3({ style { marginTop(0.px) } }) { Text("Enviar Mensaje al Panel") }
                    TextArea(value = mensajeParaAdmin, attrs = {
                        style {
                            width(100.percent); minHeight(80.px); flex(1); boxSizing("border-box"); marginBottom(8.px)
                        }
                        placeholder("Escribe un mensaje para el administrador...")
                        onInput { onMensajeParaAdminChanged(it.value) }
                    })
                    Button(attrs = {
                        onClick { onEnviarMensajeAlAdmin() }
                        style {
                            width(100.percent); padding(10.px); fontSize(16.px); fontWeight("bold"); color(Color.white);
                            backgroundColor(Color("#1A73E8")); borderRadius(8.px); cursor("pointer")
                        }
                    }) { Text("Enviar Mensaje") }
                }
            }
        }
    }
}